var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};

(function ($) {
    var FILTER_DIVISION_ID =             { name: 'selectedDivisionId',    priority: 0 }, 
        FILTER_START_DATE =            { name: 'startDate',             priority: 1, isDate: true }, 
        FILTER_END_DATE =              { name: 'endDate',               priority: 2, isDate: true }, 
        FILTER_START_DATE_SECONDARY =  { name: 'startDateSecondary',    priority: 3, isDate: true }, 
        FILTER_END_DATE_SECONDARY =    { name: 'endDateSecondary',      priority: 4, isDate: true };

    var ATTRIBUTE_FILTER_INVERTED_SUFFIX = '_INVERTED', 
        ATTRIBUTE_FILTER_PREFIX = 'df_';

    var FILTER_INVERSION_SUPPORTED = false;
    var AUTO_APPLY_FILTERS = true;

    var _dashboardFilters, 
        _isInitialized = false, 
        _isReloadingFilters = false, 
        _cachedAttributeFiltersArray,
        _applyFiltersBtn,
        _onPopstateHandlers = {}, 
        _widgetFilterApplyQueue = {
            refreshAll: false,
            filterIds: []
        }, 
        _namedFilters = [
            FILTER_DIVISION_ID,
            FILTER_START_DATE,
            FILTER_END_DATE,
            FILTER_START_DATE_SECONDARY,
            FILTER_END_DATE_SECONDARY
        ];


    //MDB.Charts.dashboardFilterInversionIsDisabled
    $.extend(MDB.Charts, {
        initDashboardFilters: function(){
            FILTER_INVERSION_SUPPORTED = !MDB.Charts.dashboardFilterInversionIsDisabled;

            if(!_dashboardFilters){
                _dashboardFilters = parseFilterValuesFromSearch();
            }

            $('.dashboard-filter[data-id]').each(function () {
                initAttributeFilter(this);
            });

            _applyFiltersBtn = $('#apply-filters-btn');

            //When an apply filter button is present; filters should not be auto applied
            AUTO_APPLY_FILTERS = !_applyFiltersBtn.length;

            _applyFiltersBtn.on('click', function(){
                refreshWidgets(true);
            });
            
            setApplyButtonStatus(false);

            _isInitialized = true;

            //Give a small window for multiple presses to occur before actually firing event
            $(window).on('popstate', _.debounce(function(e){
                //Filters changed; clear cache for widgets
                _cachedAttributeFiltersArray = undefined;

                setTimeout(function(){
                    var previousFilters = _dashboardFilters;

                    //Take filters from associated state when available
                    //Otherwise just re-parse them
                    _dashboardFilters = (e.originalEvent && e.originalEvent.state) || parseFilterValuesFromSearch();
                    _isReloadingFilters = true;

                    var initialFilters = _.filter(Object.keys(previousFilters), function(filterKey){
                        return previousFilters[filterKey].isInitialValue;
                    });

                    //Copy initial 'defaults' over to current filter object to prevent losing their values
                    //These filter values are potentially not present in the URL
                    initialFilters.forEach(function(filterKey){
                        if(!_dashboardFilters[filterKey]){
                            _dashboardFilters[filterKey] = _.cloneDeep(previousFilters[filterKey]);
                        }
                    });

                    var previousFilterKeys = _.filter(Object.keys(previousFilters), function(key){
                        return previousFilters[key];
                    });

                    var currentFilterKeys = _.filter(Object.keys(_dashboardFilters), function(key){
                        return _dashboardFilters[key];
                    });

                    //Check for each individual attribute filter whether it's value has been changed after navigation
                    //If no global 'named' filters have been changed, we should only reload the widgets utilizing the changed filters
                    //Any direct difference in keys can be assumed changed
                    var changedFilters = _.xor(
                        previousFilterKeys,
                        currentFilterKeys
                    );

                    _.intersection(previousFilterKeys, currentFilterKeys).forEach(function(filterKey){
                        var previousFilter = previousFilters[filterKey], 
                            currentFilter = _dashboardFilters[filterKey];

                        //Inversion should be the same
                        if(previousFilter.inverted !== currentFilter.inverted){
                            changedFilters.push(filterKey);
                            return;
                        }

                        var previousFilterValues = previousFilter && previousFilter.values ? previousFilter.values : [];
                        var currentFilterValues = currentFilter && currentFilter.values ? currentFilter.values : [];

                        //If the amount of values has changed assume something changed
                        if(previousFilterValues.length !== currentFilterValues.length){
                            changedFilters.push(filterKey);
                            return;
                        }

                        //Check the exact difference as a final step
                        if(_.xor(previousFilterValues, currentFilterValues).length) {
                            changedFilters.push(filterKey);
                        }
                    });

                    var globalFiltersChanged = _.intersection(_.map(_namedFilters, 'name'), changedFilters).length;

                    //Selected values could be dependant upon division id, force reloading of all filters
                    if(changedFilters.indexOf(FILTER_DIVISION_ID.name) !== -1){
                        changedFilters = _.sortBy(Object.keys(_dashboardFilters), function(filterKey){
                            return filterKey === FILTER_DIVISION_ID.name ? 0 : 1;
                        });
                    }

                    var proms = [];

                    //Only reload filters that actually got changed
                    changedFilters.forEach(function(filterKey){
                        //Allow for all UI components, etc to refresh before reloading widgets
                        _onPopstateHandlers[filterKey].forEach(function(handler){
                            var res = handler();
                            if(res && res.done && res.fail){
                                proms.push(res);
                            }
                        });
                    });

                    $.when.apply($, proms)
                        .always(function () {
                            if(globalFiltersChanged){
                                refreshAllWidgets();
                            } else{
                                changedFilters.forEach(function (filterKey) {
                                    refreshAllWidgetsWithAttributeFilter(filterKey);
                                });
                            }

                            //Navigation is user input
                            refreshWidgets(true);
                        });

                    _isReloadingFilters = false;
                }, 0);
            }, 500));
        },
        setupDatePicker: function (elementSelector, options, secondaryDate) {
            if(!_dashboardFilters){
                _dashboardFilters = parseFilterValuesFromSearch();
            }

            var element = $(elementSelector);

            var startDateKey = 'dateStart';
            var endDateKey = 'dateEnd';

            var startDateFilter = FILTER_START_DATE;
            var endDateFilter = FILTER_END_DATE;

            if(secondaryDate){
                startDateKey += 'Secondary';
                endDateKey += 'Secondary';

                startDateFilter = FILTER_START_DATE_SECONDARY;
                endDateFilter = FILTER_END_DATE_SECONDARY;
            }

            options.dateFormat = MDB.Charts.dateFilterInputFormat;
            var sessionKey = secondaryDate ? 'mdb_graph_dates_secondary' : 'mdb_graph_dates';

            //When visible: URL > Defaults > Session
            //When hidden: Always take defaults

            var getSelectedDateRange = function(){
                var startDate, 
                    endDate;

                if(options.visible){
                    if (window.sessionStorage && !options.ignoreCache && !options.defaultDateRangeFilter) {
                        if (window.sessionStorage[sessionKey]) {
                            var dates = JSON.parse(window.sessionStorage[sessionKey]);
                            if (dates.dateStart && dates.dateStart !== 'Invalid date') {
                                startDate = dates.dateStart;
                            }
                            if (dates.dateEnd && dates.dateEnd !== 'Invalid date') {
                                endDate = dates.dateEnd;
                            }
                        }
                    }

                    if(_dashboardFilters[startDateFilter.name]){
                        startDate = moment(_dashboardFilters[startDateFilter.name].values[0], MDB.Charts.dateFilterFormat).format(options.dateFormat);
                    }

                    if(_dashboardFilters[endDateFilter.name]){
                        endDate = moment(_dashboardFilters[endDateFilter.name].values[0], MDB.Charts.dateFilterFormat).format(options.dateFormat);
                    }
                }

                if (!startDate) {
                    // default:
                    if (!secondaryDate && !options.defaultDateRangeFilter) {
                        startDate = moment(new Date()).format(options.dateFormat);
                        endDate = moment(new Date()).format(options.dateFormat);
                    } else {
                        startDate = '';
                        endDate = '';
                    }
                }

                return {
                    startDate: startDate,
                    endDate: endDate
                };
            };

            var initialRange = getSelectedDateRange();

            if(!options.sessionStartDate) {
                options.sessionStartDate = initialRange.startDate;
            }
            if(!options.sessionEndDate) {
                options.sessionEndDate = initialRange.endDate;
            }

            options.callback = function (dateStart, dateEnd) {
                if (window.sessionStorage) {
                    window.sessionStorage[sessionKey] = JSON.stringify({ dateStart: dateStart, dateEnd: dateEnd });
                }

                // convert to Y-M-D
                dateStart = moment(dateStart, options.dateFormat).format(MDB.Charts.dateFilterFormat);
                dateEnd = moment(dateEnd, options.dateFormat).format(MDB.Charts.dateFilterFormat);

                MDB.Charts[startDateKey] = dateStart;
                MDB.Charts[endDateKey] = dateEnd;

                //Widgets always get refreshed after filter reload
                //We do not want to overwrite history nor want to reload the widgets
                if(!_isReloadingFilters){
                    if(dateStart){
                        _dashboardFilters[startDateFilter.name] = {
                            values: [dateStart],
                            priority: startDateFilter.priority,
                            isInitialValue: !_isInitialized
                        };
                    }

                    if(dateEnd){
                        _dashboardFilters[endDateFilter.name] = {
                            values: [dateEnd],
                            priority: endDateFilter.priority,
                            isInitialValue: !_isInitialized
                        };
                    }

                    // reload each widget
                    refreshAllWidgets();
                    saveActiveFiltersToBrowserHistory();
                }
            };

            var pickerEl = element.mdbDatepicker(options), 
                picker = pickerEl.data('mdbDatepicker');

            var onPopstate = function(){
                var range = getSelectedDateRange();

                if(range.startDate && range.endDate){
                    picker.setDateRange(range.startDate, range.endDate);
                } else{
                    picker.resetDateRange();
                }
            };

            registerPopstateHandler(startDateFilter.name, onPopstate);
            registerPopstateHandler(endDateFilter.name, onPopstate);
        },
        setupDivisionSelector:function(elementSelector, options) {
            if(!_dashboardFilters){
                _dashboardFilters = parseFilterValuesFromSearch();
            }

            if(options && !options.visible){
                //Initialize Charts.divisionId with default value and back out

                var setStaticValue = function(){
                    MDB.Charts.divisionId = MDB.CurrentUser.DivisionId;

                    //Ensure parameter does not end up in URL again
                    if(_dashboardFilters[FILTER_DIVISION_ID.name]){
                        delete _dashboardFilters[FILTER_DIVISION_ID.name];
                    }
                };

                setStaticValue();
                registerPopstateHandler(FILTER_DIVISION_ID.name, setStaticValue);

                return;
            }

            var select = $(elementSelector);
            if(_dashboardFilters[FILTER_DIVISION_ID.name]){
                select.val(_dashboardFilters[FILTER_DIVISION_ID.name].values[0]);
            }

            var saveSelectedValue = function(){
                var selectedValue = select.val();

                if(!MDB.isGuid(selectedValue)){
                    selectedValue = MDB.CurrentUser.DivisionId;
                }

                MDB.Charts.divisionId = selectedValue;

                _dashboardFilters[FILTER_DIVISION_ID.name] = {
                    values: [selectedValue],
                    priority: FILTER_DIVISION_ID.priority,
                    isInitialValue: !_isInitialized
                };
            };

            saveSelectedValue();

            select.on('change', function(){
                var previousSelectedValue = MDB.Charts.divisionId;

                saveSelectedValue();

                //When selecting one's own division, filters should still be saved to history
                saveActiveFiltersToBrowserHistory();

                if(previousSelectedValue !== MDB.Charts.divisionId){
                    reloadDashboardFilters().done(function(){
                        refreshAllWidgets();
                    });
                }
            });

            registerPopstateHandler(FILTER_DIVISION_ID.name, function(){
                var filter = _dashboardFilters[FILTER_DIVISION_ID.name];

                if(filter){
                    select.val(filter.values[0]);
                }

                saveSelectedValue();
            });
        },
        setFilters: function(filters){
            if(!filters){
                return;
            }

            if(!_dashboardFilters){
                _dashboardFilters = {};
            }

            //Convert filters to internal API format
            var internalFilters = normalizeFilters(filters);

            var changedFilterIds = Object.keys(internalFilters);

            //Replace all internal filters with the provided external filters
            changedFilterIds.forEach(function(filterId){
                _dashboardFilters[filterId] = internalFilters[filterId];
            });

            //Save filters to history + trigger popstate in order to automagically reload the necessary filters
            saveActiveFiltersToBrowserHistory();

            //Popstate checks for the 'previous' filters in the _dashboardFilters object
            //Clear our altered keys to work around its caching :-)
            changedFilterIds.forEach(function(filterId){
                _dashboardFilters[filterId].values = [];
            });

            $(window).trigger('popstate');
        },
        appendActiveFiltersToUrl: function(url){
            return MDB.Charts.appendFiltersToUrl(url, _dashboardFilters);
        },
        appendFiltersToUrl: function(url, filters){
            if(!filters){
                return url;
            }

            //Convert filters to internal API format
            var internalFilters = normalizeFilters(filters);

            var encodedFilters = encodeFilters(internalFilters);

            //No point in attempting to append an empty filter array to our URL
            if (!encodedFilters.length) {
                return url;
            }

            var queryStringParameterSeparator = '?';
            if(url && url.indexOf('?') !== -1) {
                queryStringParameterSeparator = '&';
            }
            
            if(_.endsWith(url, '?') || _.endsWith(url, '&')){
                //Directly append first filter
                queryStringParameterSeparator = '';
            }
            
            //String.prototype.endsWith native function is not supported in IE 11
            // if (!(_.endsWith(url, '?') && _.endsWith(url, '&'))){
            //     url += url.indexOf('?') === -1 ? '?' : '&';
            // }

            return _.reduce(_.concat(url, encodedFilters), function (url, filter) {
                if (url === undefined){
                    return filter;
                }

                var urlWithFilter = [url, filter].join(queryStringParameterSeparator);
                
                //Ensure all succeeding filters get concatted via a '&'
                queryStringParameterSeparator = '&';
                
                if (urlWithFilter.length >= MDB.maxUrlLength){
                    return url;
                }

                return urlWithFilter;
            });
        },
        getWidgetArraySerializedFilters: function(widget){
            var serializedFilters = MDB.Charts.getArraySerializedFilters();
            var widgetFilters = MDB.Charts.getWidgetDashboardFilterIds(widget);

            return _.filter(serializedFilters, function(f){
                return widgetFilters.indexOf(f.attributeId) !== -1;
            });
        },
        getArraySerializedFilters: function() {
            if(!_dashboardFilters){
                return undefined;
            }

            if(_cachedAttributeFiltersArray){
                return _cachedAttributeFiltersArray;
            }

            var attributeFilterIds = _.filter(Object.keys(_dashboardFilters), function(filterId){
                return _dashboardFilters[filterId].isAttributeFilter;
            });

            var attributeFiltersArray = _.map(attributeFilterIds, function(attributeId){
                return {
                    attributeId: attributeId,
                    values: _dashboardFilters[attributeId].values,
                    isInverted: _dashboardFilters[attributeId].inverted,
                    startDate: MDB.Charts.dateStart,
                    endDate: MDB.Charts.dateEnd
                };
            });

            //Values don't change often and the function is invoked once per widget load
            //Hence we should cache the values
            _cachedAttributeFiltersArray = attributeFiltersArray;

            return attributeFiltersArray;
        }
    });

    function initAttributeFilter (el) {
        el = $(el);
        var filterConfig = getDashboardFilterConfiguration(el), 
            attributeId = filterConfig.attributeId, 
            isMulti = filterConfig.isMulti, 
            filterValue = filterConfig.getFilterValues(), 
            placeholder = filterConfig.placeholder;

        var config = {
            dataSource: createRemoteDashboardFilterDataSource(filterConfig),
            autoBind: false,
            autoClose: false,
            placeholder: placeholder,
            filter: 'contains',
            value: isMulti ? filterValue : filterValue[0],
            optionLabel: placeholder,
            change: _.debounce(function(){
                //Invalidate cache
                _cachedAttributeFiltersArray = undefined;
                
                var value = el.val();

                _dashboardFilters[attributeId] = createAttributeFilter(value, filterConfig.isInverted());
                
                refreshAllWidgetsWithAttributeFilter(attributeId);
                saveActiveFiltersToBrowserHistory();
                
                refreshAllOtherMultiDashboardFilters([attributeId]);
            }, 1000)
        };

        if(!isMulti && filterValue.length === 1) {
            config = $.extend(config, { text: config.value });
        }
        
        // if(isMulti){
            // We need the kendoMultiselect to update their dataSource when they are opened.
            // However I did not succeed in disabling kendo's built in caching. So we will call the read()
            // when we need it ourselves.
            // config.open = function(){
            //     reloadDashboardFilterDataSource(filterConfig);
            // }
        // }


        el.removeClass('hidden');
        el[filterConfig.kendoControlName](config);

        var kendoControl = el.data(filterConfig.kendoControlName);

        registerPopstateHandler(filterConfig.attributeId, function(){
            var value = filterConfig.getFilterValues();
            value = isMulti ? value : value[0];

            return $.Deferred(function(def){
                var filterConfig = getDashboardFilterConfiguration(el);
                filterConfig.onReadComplete = function(){
                    kendoControl.value(value);
                    def.resolve();
                };

                reloadDashboardFilterDataSource(filterConfig);
            }).promise();
        });

        setupInvertedToggle(el, filterConfig.kendoControlName);
    }

    function setupInvertedToggle (el, controlType){
        if(!FILTER_INVERSION_SUPPORTED){
            return;
        }

        el = $(el);

        var filterConfig = getDashboardFilterConfiguration(el);

        var control = el.data(controlType);
        var defaultState = el.data('inverted') !== undefined ? el.data('inverted') : 'default';

        var invertedToggleConfig = {
            default: {
                nextState: false,
                color: '#708090',
                classList: 'fas new'
            },
            false: {
                nextState: true,
                color: '#00C851',
                classList: 'fas delete'
            },
            true: {
                nextState: false,
                color: '#ff4444',
                classList: 'fas new' // changed far into fas, because we don't have a far version for the fa-filter icon
            }
        };

        var invertedToggleControl = $('<i />', {'class': 'fa-filter dashboard-filter-inverted-toggle iconButton mdb-icon-btn'})
            .css({'color': invertedToggleConfig[defaultState].color})
            .addClass(invertedToggleConfig[defaultState].classList);

        //Buggy, inconsistent visuals
        control.wrapper.find('span.k-select').remove();

        control.wrapper.parent().append(invertedToggleControl);

        var switchState = function(newState){
            //Actual state should either be undefined or a boolean
            //Name can still be a string however
            var newStateName = newState === undefined ? 'default' : newState;

            var currentState = filterConfig.isInverted();

            // var currentState = control.element.data('inverted');
            if(currentState === undefined || !invertedToggleConfig[currentState]){
                currentState = 'default';
            }

            var currentStateConfig = invertedToggleConfig[currentState], 
                newStateConfig = invertedToggleConfig[newStateName];

            invertedToggleControl.css({color: newStateConfig.color})
                .removeClass(currentStateConfig.classList)
                .addClass(newStateConfig.classList);

            if(!_dashboardFilters[filterConfig.attributeId]){
                _dashboardFilters[filterConfig.attributeId] = createAttributeFilter();
            }

            _dashboardFilters[filterConfig.attributeId].inverted = newState;
        };

        invertedToggleControl.on('click', function(){
            var filter = _dashboardFilters[filterConfig.attributeId];
            var currentState = filter !== undefined ? filter.inverted : undefined;

            if(currentState === undefined || !invertedToggleConfig[currentState]){
                currentState = 'default';
            }

            var currentStateConfig = invertedToggleConfig[currentState];

            switchState(currentStateConfig.nextState);

            control.trigger('change');
        });

        registerPopstateHandler(filterConfig.attributeId, function(){
            switchState(filterConfig.isInverted());
        });

        //'Switch' to current state
        switchState(filterConfig.isInverted());
    }

    function normalizeFilters(dashboardFilters){
        //Filters can either be an object in our internal format; or an array
        //When the object passed in is not in our internal format, convert it to an array
        if(!_.isArray(dashboardFilters) && (dashboardFilters.filterId || dashboardFilters.attributeId)){
            dashboardFilters = [dashboardFilters];
        }

        //An object is assumed to be in the correct format
        if(!_.isArray(dashboardFilters)){
            return dashboardFilters;
        }

        var normalizedFilters = {};

        //Arrays have to be formatted to match our internal format prior to encoding
        dashboardFilters.forEach(function(filter){
            //Workaround for inconsistent naming;
            //When reading filters, attribute/'special' filters get merged into one blob
            //This with each and every filter receiving an 'attributeId' property
            //FilterId is the more correct naming however, as this also encompasses division/date filters
            var filterId = filter.filterId || filter.attributeId;

            //Attempt to infer by filterId
            var isAttributeFilter = MDB.isGuid(filterId);

            //Ensure our values are actually an array
            var values = _.isArray(filter.values) ? filter.values : [filter.values];

            normalizedFilters[filterId] = {
                values: values,
                inverted: filter.inverted,
                priority: filter.priority,
                isAttributeFilter: isAttributeFilter
            };
        });

        return normalizedFilters;
    }

    function encodeFilters(dashboardFilters){
        if(!dashboardFilters){
            return [];
        }

        //Filters with a lower priority value are more important and should be placed in the URL first 
        var filterIds = _.orderBy(Object.keys(dashboardFilters), function(filterId){
            return dashboardFilters[filterId].priority;
        });

        return _.flatMap(filterIds, function (filterId) {
            var filterConf = dashboardFilters[filterId], 
                values = filterConf.values, 
                inverted = filterConf.inverted, 
                parameterPrefix = filterConf.isAttributeFilter ? ATTRIBUTE_FILTER_PREFIX : '', 
                parameterName = parameterPrefix + filterId;

            var parameters = _.map(values, function (filterValue) {
                return parameterName + '=' + encodeURIComponent(filterValue);
            });

            if(inverted !== undefined){
                parameters.push(parameterName + ATTRIBUTE_FILTER_INVERTED_SUFFIX + '=' + encodeURIComponent(inverted));
            }

            return parameters;
        });
    }

    function getEncodedActiveFilters(){
        return encodeFilters(_dashboardFilters);
    }

    function parseFilterValuesFromSearch(){
        var search = window.location.search, 
            parsedFilters = {};

        //df_(.+)
        var attributeFilterRegex = new RegExp(ATTRIBUTE_FILTER_PREFIX + '(.+)');

        //df_(.+)_INVERTED
        var attributeFilterInvertedRegex = new RegExp(ATTRIBUTE_FILTER_PREFIX + '(.+)' + ATTRIBUTE_FILTER_INVERTED_SUFFIX);

        if(!search){
            return parsedFilters;
        }

        //Named parameter: name=value...
        //Attribute parameter: df_name=value...
        //Inversion parameter: df_name_inverted={bool}...

        search.split('&').forEach(function(filter){
            //Ignore the start of the querystring
            if(filter.indexOf('?') === 0){
                filter = filter.substring(1);
            }

            //https://stackoverflow.com/a/24417399
            //.NET escapes spaces with a 'plus' sign when using HttpUtility.UrlEncode 
            filter = filter.replace(/\+/g, '%20');

            var kv = filter.split('='), 
                key = decodeURIComponent(kv[0]), 
                value = decodeURIComponent(kv[1]);

            var namedParam = _.find(_namedFilters, {name: key});

            if(namedParam){
                if(namedParam.isDate){
                    var strictMoment = moment(value, MDB.Charts.dateFilterFormat, true);

                    //Values provided by script generated URL are always in the proper format
                    //In case the value is not in the correct format, moment should be able to infer it
                    if(!strictMoment.isValid()){
                        value = moment(value).format(MDB.Charts.dateFilterFormat);
                    }
                }

                parsedFilters[namedParam.name] = {
                    values: [value],
                    priority: namedParam.priority
                };

            } else{
                //Attribute parameter
                var regex = attributeFilterRegex, 
                    isInvertedParameter = false;

                if(attributeFilterInvertedRegex.test(key)){
                    regex = attributeFilterInvertedRegex;
                    isInvertedParameter = true;
                }

                var match = regex.exec(key);

                //Non filter parameter (chromeless, takescreenshot, etc...), just ignore those
                if(!match){
                    // console.warn('Could not match dashboard parameter: ' + key);
                    return;
                }


                key = match[1];

                var attributeFilter = parsedFilters[key];
                if(!attributeFilter){
                    attributeFilter = parsedFilters[key] = createAttributeFilter();
                }

                if(isInvertedParameter){
                    //URLs generated by screenshot task use .NET boolean strings
                    attributeFilter.inverted = /true/i.test(value);
                } else{
                    attributeFilter.values.push(value);
                }
            }
        });

        return parsedFilters;
    }

    function saveActiveFiltersToBrowserHistory () {
        //Prevent overwriting existing URL when not all filters have been properly initialized
        if(!_isInitialized || _isReloadingFilters){
            return;
        }

        if (typeof (history) !== 'undefined') {
            var filters = getEncodedActiveFilters();

            history.pushState(_dashboardFilters, document.title, location.pathname + '?' + filters.join('&'));
        }
    }
    
    function refreshAllOtherMultiDashboardFilters(excludedAttributeIds){
        //Only refresh multi filters for now
        //refreshing a singular filter causes it to (at least visibly) break when a value was selected
        //We need to specifically look at the elements to find out which filters are available on the page
        //looking at our '_dashoardFilters' can also contain filters only present in the realm of our URL
        $('.dashboard-filter-multiple.dashboard-filter[data-short-id]')
            .filter(function() { 
                return excludedAttributeIds.indexOf(this.dataset.shortId)  === -1; 
            })
            .each(function(){
                var filterConfig = getDashboardFilterConfiguration(this);
                refreshDashboardFilter(filterConfig);
            });
    }
    
    function refreshDashboardFilter(filterConfig) {
        var kendoControl = filterConfig.getKendoControl();
        var newDataSource = createRemoteDashboardFilterDataSource(filterConfig);
        
        //New DataSource will only be used if we actively call 'refresh' post-set
        kendoControl.setDataSource(newDataSource);
        kendoControl.refresh();
    }
    
    function refreshAllWidgetsWithAttributeFilter(attributeId){
        _widgetFilterApplyQueue.filterIds.push(attributeId);
        return refreshWidgets(false);
    }
    
    function refreshAllWidgets(){
        _widgetFilterApplyQueue.refreshAll = true;

        return refreshWidgets(false);
    }
    
    function refreshWidgets(isUserInput) {
        if(!AUTO_APPLY_FILTERS && !isUserInput){
            setApplyButtonStatus(true);
            
            //Mimic success response
            return $.Deferred()
                .resolve()
                .promise();
        }
        
        var prom;

        if(_widgetFilterApplyQueue.refreshAll) {
            prom = MDB.Charts.refreshAllWidgets();
        } else {
            //Wait for each individual filter to resolve prior to resolving
            //when a single widgets gets reloaded multiple times; the previous reloads should get cancelled
            prom = $.Deferred(function(d){
                var individualReloadProms = MDB.Charts.refreshAllWidgetsWithDashboardFilters(_widgetFilterApplyQueue.filterIds);
                
                // var individualReloadProms = _widgetFilterApplyQueue.filterIds.map(function(filterId){
                //     return MDB.Charts.refreshAllWidgetsWithDashboardFilters(filterId);
                // });  
                
                $.when.apply($, individualReloadProms)
                    .done(function () {
                        d.resolve(); 
                    })
                    .fail(function () { 
                        d.reject(); 
                    });
            }).promise();
        }

        //Reset queue to initial state once we're done
        _widgetFilterApplyQueue.filterIds = [];
        _widgetFilterApplyQueue.refreshAll = false;

        setApplyButtonStatus(false);
        
        return prom;
    }
    
    function setApplyButtonStatus(enabled){
        //Apply button reference might not be available yet
        if(_applyFiltersBtn){
            _applyFiltersBtn.attr('disabled', !enabled);   
        }
    }
    
    function reloadDashboardFilters() {
        return $.Deferred(function(def){
            //Keep track of a counter due to the asynchronous nature of the calls
            var completeCounter = 0;
            var filters = $('.dashboard-filter[data-id]');

            if (filters.length === 0){
                def.resolve();
                return;
            }

            filters.each(function () {
                var filterConfig = getDashboardFilterConfiguration(this);

                filterConfig.onReadComplete = function () {
                    completeCounter++;

                    if (completeCounter === filters.length) {
                        def.resolve();
                    }
                };

                reloadDashboardFilterDataSource(filterConfig);
            });
        }).promise();
    }

    function reloadDashboardFilterDataSource(filterConfig) {
        var el = filterConfig.element;

        var kendoControl = el.data(filterConfig.kendoControlName);
        var dataSource = createRemoteDashboardFilterDataSource(filterConfig);

        kendoControl.setDataSource(dataSource);
        return kendoControl.dataSource.read();
    }

    function createRemoteDashboardFilterDataSource (filterConfig) {
        var el = filterConfig.element;
        return {
            serverFiltering: true,
            transport: {
                read: function (options) {       
                    var filter = options.data.filter;

                    $.ajax({
                        url: $('body').data('siteroot') + 'api' + el.data('url'),
                        contentType: 'application/json',
                        dataType: 'json',
                        cache: false,
                        data: {
                            attributeId: filterConfig.attributeId,
                            entityId: filterConfig.entityId,
                            filter: filter,
                            inverted: filterConfig.isInverted(),
                            divisionId: MDB.isGuid(MDB.Charts.divisionId) ? MDB.Charts.divisionId : null,
                            dashboardFilters: MDB.Charts.getArraySerializedFilters()
                        },
                        success: function (result) {
                            var kendoControl = el.data(filterConfig.kendoControlName);

                            if (result.length < 500 && !filter) {
                                var localDataSource = new kendo.data.DataSource({ data: result });

                                kendoControl.setDataSource(localDataSource);
                                localDataSource.success(result);
                            } else {
                                //Ensure any previously selected values are always present in the data collection
                                result.push.apply(
                                    result,
                                    _.xor(filterConfig.getFilterValues(), result)
                                );
                            }

                            options.success(result);


                            //**
                            // Feature disabled. Causes filter to clear data when not the whole dataset is loaded. 
                            //**
                            //Remove any now non present items
                            //var value = kendoControl.value();
                            //kendoControl.value(_.filter(value, function(item){ return result.indexOf(item) !== -1 }));

                            el.trigger('mdb:data-loaded');
                            filterConfig.onReadComplete();
                        }
                    });
                }
            }
        };
    }

    function registerPopstateHandler(key, fn){
        if(!_onPopstateHandlers[key]){
            _onPopstateHandlers[key] = [];
        }

        _onPopstateHandlers[key].push(fn);
    }

    function createAttributeFilter(value, inverted){
        if(value === undefined){
            value = [];
        }

        value = _.isArray(value) ? value : [value];

        return {
            //Undefined/Null are always invalid values, ignore them
            values: _.filter(value, function(v){
                return v !== undefined && v !== null; 
            }),
            inverted: inverted,
            isAttributeFilter: true,
            isInitialValue: !_isInitialized
        };
    }
    
    function getDashboardFilterConfiguration(el) {
        el = $(el);

        var attributeTokens = el.data('id').split('.'), 
            entityId = attributeTokens[0], 
            attributeId = attributeTokens[1], 
            isMulti = el.hasClass('dashboard-filter-multiple'), 
            kendoControlName = isMulti ? 'kendoMultiSelect': 'kendoDropDownList';

        return {
            element: el,
            kendoControlName: kendoControlName,
            isMulti: isMulti,
            placeholder: el.attr('placeholder'),
            entityId: entityId,
            attributeId: attributeId,

            //Kendo resolves its datasource.read(...) promise too early
            //onReadComplete aims to resolve this issue by firing after kendo's success handler
            onReadComplete: $.noop,
            getKendoControl: function(){
                return el.data(kendoControlName);
            },
            getFilterValues: function(){
                var filter = _dashboardFilters[attributeId];

                if(filter && filter.values){
                    return filter.values;
                }

                return [];
            },
            isInverted: function(){
                if(!FILTER_INVERSION_SUPPORTED){
                    return undefined;
                }

                var filter = _dashboardFilters[attributeId];

                if(!filter || filter.inverted === undefined){
                    return undefined;
                }

                return filter.inverted;
            }
        };
    }
})(jQuery);